import { env } from '@/env/env';

/**
 * Dark mode is not user-reachable yet: the Signal Ocean token swap has only landed for
 * HSQE and the shared primitives, while VOY still carries hardcoded light-mode hex
 * (FixtureConsumptionSettlement, FixtureDeliveryBunkerList, TCCalculationViewer,
 * VoyageCalculationToolbar, the estimator/tc-in CSS), which would render light-on-light
 * under the dark ramp.
 *
 * The flag governs the RESOLVED theme, not just the toggle: `Providers` forces `light`
 * and disables system detection while it is off, so a `theme=dark` value persisted by
 * next-themes (from a build where the toggle was reachable) cannot strand a user in a
 * broken dark render with no toggle left to escape it. Remove the flag once every module
 * is tokenised.
 */
export const isDarkModeEnabled = env.VITE_ENABLE_DARK_MODE === 'true';
